var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNiceHouse = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 398.98 355.04"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 28",
  d: "M334.088 149.488a14.986 14.986 0 01-14.971-15V50.594a14.971 14.971 0 1129.942 0v83.894a14.986 14.986 0 01-14.971 15z",
  fill: "#ed6c7b"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 29",
  d: "M34.65 354.038v-197.4a5.006 5.006 0 011.679-3.74L195.679 11.26a4.982 4.982 0 016.623 0l159.35 141.635a5.008 5.008 0 011.679 3.74v197.403H34.65z",
  fill: "#fff2de"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 30",
  d: "M361.653 152.895L202.303 11.26a4.983 4.983 0 00-3.312-1.26v344.038h164.341v-197.4a5.008 5.008 0 00-1.679-3.743z",
  fill: "#fde4c3"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 31",
  d: "M164.396 354.038H74.571V197.422a14.986 14.986 0 0114.971-15h59.883a14.986 14.986 0 0114.971 15z",
  fill: "#a34f3e"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 32",
  d: "M293.163 269.91h-51.17a10.6 10.6 0 01-10.589-10.609v-51.27a10.6 10.6 0 0110.589-10.609h51.17a10.6 10.6 0 0110.589 10.609v51.27a10.6 10.6 0 01-10.589 10.609z",
  fill: "#c8ffff"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 33",
  d: "M303.752 284.91h-72.347a14.986 14.986 0 01-14.971-15v-72.488a14.986 14.986 0 0114.971-15h72.347a14.986 14.986 0 0114.971 15v72.488a14.987 14.987 0 01-14.971 15zm-57.377-30h42.4v-42.488h-42.396z",
  fill: "#a34f3e"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 34",
  d: "M383.006 193.562a14.888 14.888 0 01-9.929-3.779L198.991 35.052 24.906 189.783a14.988 14.988 0 01-19.869-22.445L189.057 3.776a14.949 14.949 0 0119.869 0l184.02 163.562a15 15 0 01-9.94 26.221z",
  fill: "#ed6c7b"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 35",
  d: "M392.946 167.338L208.926 3.779A14.919 14.919 0 00198.991 0v35.051l174.088 154.731a14.987 14.987 0 0019.87-22.441z",
  fill: "#d65b72"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36",
  d: "M387.313 355.038H11.666c-6.443-.19-11.667-6.906-11.667-15.19s5.223-15 11.666-15h375.648c6.443 0 11.666 6.716 11.666 15s-5.223 15-11.666 15.19z",
  fill: "#dafcdb"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 37",
  d: "M387.284 323.848H198.991v30.19h188.292c6.46-.192 11.7-6.908 11.7-15.192s-5.237-15-11.7-15z",
  fill: "#b6fcd1"
})));
export default SvgNiceHouse;